export const SOCIAL_WOLVES_HOME = 'https://socialwolvez.com/'